import { TECHS } from "../../../config/constants";
import React from "react";
import { SiGithub } from "react-icons/si";
import { BiLinkExternal } from "react-icons/bi";

interface Interface {
  title: string;
  description: string;
  link?: string;
  image: string;
  openSource?: boolean;
  techs: string[];
  year: number;
  client?: string;
}

export default function Project(attributes: Interface) {
  const isExternal = attributes.link && attributes.link !== "/";

  const content = (
    <div className="flex flex-col md:flex-row gap-0 w-full group">
      {/* Image */}
      <div className="md:w-2/5 w-full shrink-0 overflow-hidden rounded-t-xl md:rounded-l-xl md:rounded-tr-none">
        <img
          className="w-full h-full aspect-[3/2] md:aspect-auto object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          src={attributes.image}
          alt={attributes.title}
        />
      </div>

      {/* Content */}
      <div className="flex flex-col gap-3 p-5 flex-1 min-w-0">
        {/* Header row */}
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            {attributes.openSource && (
              <SiGithub className="text-gray-400 shrink-0" size={16} />
            )}
            <span className="font-semibold text-white leading-snug group-hover:text-green-300 transition-colors duration-200">
              {attributes.title}
            </span>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {isExternal && (
              <BiLinkExternal size={14} className="text-gray-600 group-hover:text-gray-400 transition-colors duration-200" />
            )}
            <span className="text-xs text-gray-600 font-mono">
              {attributes.year}
            </span>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-700/60" />

        {/* Description */}
        <p
          className="text-gray-400 text-sm leading-relaxed flex-1"
          dangerouslySetInnerHTML={{ __html: attributes.description }}
        />

        {/* Bottom row: techs*/}
        <div className="flex items-end justify-between gap-2 pt-1 flex-wrap">
          {/* Tech icons */}
          <div className="flex flex-wrap gap-x-3 gap-y-2">
            {attributes.techs.map((name) => {
              const tech = TECHS.find((t) => t.name === name);
              return tech ? (
                <span
                  key={name}
                  className="flex items-center gap-1.5 text-xs text-gray-500"
                >
                  <img
                    src={tech.icon}
                    alt={tech.title}
                    className="w-4 h-4 object-contain"
                  />
                  {tech.title}
                </span>
              ) : null;
            })}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="rounded-xl bg-gray-800/60 border border-gray-700/40 hover:border-gray-600/70 overflow-hidden transition-all duration-300 hover:shadow-lg hover:shadow-black/20">
      {isExternal ? (
        <a href={attributes.link} target="_blank" rel="noreferrer" className="block">
          {content}
        </a>
      ) : (
        <div>{content}</div>
      )}
    </div>
  );
}
